import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { translations } from '../../json/data';
import { useSnackbar } from "../context/SnackbarContext";

import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase-config';

// imh
import envelope from "../../img/envelope.png"
import logo from "../../img/hint-popup/lol.png"
import { useLanguage } from '../context/Languagecontext';
import { convertToNativeNumerals } from '../../utils/numberUtils';


const CompletePopup = ({ showSuccessModal, data, category, username, timestamp, bg }) => {
    const { lanText, t } = useLanguage();
    const [count, setCount] = useState(128);
    const [sourceid, setSourceid] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(false); // New state for button disable
    const { showSnackbar } = useSnackbar();
    const isSmallScreen = window.innerWidth <= 375;
    const isiOS2 = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const timeoutDuration = isiOS2 ? 3500 : 2000;

    console.log(sourceid);

    const navigate = useNavigate();

    useEffect(() => {
        if (!showSuccessModal) return; // guard add karo

        logEvent(analytics, "send_card", {
            page_location: `${window.location.origin}/${username}/${category}`,
            page_path: `/${username}/${category}`,
            debug: 'true'
        });
        sessionStorage.setItem("timer", "true");

        const interval = setInterval(() => {
            setCount(prevCount => prevCount + (Math.random() > 0.5 ? 1 : 2));
        }, 1000);

        const fetchSourceId = async () => {
            try {
                const res = await fetch("https://api.lolcards.link/api/web/catgory/webinstall", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ category, username, timestamp })
                });
                const data = await res.json();
                setSourceid(data?.sourceid || "");
            } catch (err) {
                console.error("WebInstall API error:", err);
            }
        };

        fetchSourceId();

        return () => clearInterval(interval);

    }, [category, timestamp, username, showSuccessModal]); // ✅ showSuccessModal add karyu


    const user = data?.question;
    let subCat = 'RnJpZW5k';


    useEffect(() => {
        if (!showSuccessModal) return;

        sessionStorage.removeItem("sessionHint")
        sessionStorage.removeItem("sessionImage")
        sessionStorage.removeItem("next")
        sessionStorage.removeItem("que5next");
        sessionStorage.removeItem("que8next");

        sessionStorage.removeItem("steppage_annoyans");
        sessionStorage.removeItem("steppage_scratched");
        sessionStorage.removeItem("steppage_nickname");

        sessionStorage.removeItem('cat3SelectedImage');
        sessionStorage.removeItem('cat3IsAvatarImage');

        sessionStorage.removeItem('category7_activeIndex');
        sessionStorage.removeItem('category7_tabContents');

        // sessionStorage.setItem("timer", "true");


        // setTimeout(() => {
        //     const timer = sessionStorage.getItem("timer");

        //     if (timer === "true" && navigator.onLine) {
        //         if (category === "V2hvVGFsa2lu") {
        //             navigate(`/${username}/${category}`);
        //         } else if (category === "UGljIFJvYXN0") {
        //             navigate(`/${username}/${category}/${timestamp}`);
        //         } else {
        //             navigate(`/${username}/${category}`);
        //         }
        //     }
        // }, timeoutDuration);

    }, [showSuccessModal, sourceid, category, username, timestamp, navigate, timeoutDuration]);

    if (category === "RnJpZW5k") {
        subCat = Array.isArray(user)
            ? user.find(item => item.category === category)?.answer.subCategory
            : "RnJpZW5k";
    }


    const isAndroid = /Android/i.test(navigator.userAgent);
    const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    const checkInternetConnection = async () => {
        // Add 2 second delay
        await new Promise(resolve => setTimeout(resolve, 1000));

        // First check navigator.onLine
        if (!navigator.onLine) {
            return false;
        }

        // Double-check with a real network request
        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

            clearTimeout(timeoutId);
            return true;
        } catch (error) {
            console.log('Network check failed:', error);
            return false;
        }
    };

    const handlePlaystoreClick = async () => {
        if (isButtonDisabled) return; // Prevent action if disabled
        setIsButtonDisabled(true); // Disable all buttons

        // sessionStorage.setItem("timer", "false");
        const isOnline = await checkInternetConnection();
        if (!isOnline) {
            showSnackbar(t?.completePopup?.nointertoast || "Please turn on internet connection!", "error");
            setIsButtonDisabled(false); // Re-enable if error
            return;
        }
        logEvent(analytics, 'web_redirect', {
            page_location: `${window.location.origin}/${username}/${category}`,
            page_path: `/${username}/${category}`,
            debug: 'true',
        });

        let playStoreURL = 'https://play.google.com/store/apps/details?id=com.lol.android';
        let appStoreURL = 'https://apps.apple.com/us/app/lol-anonymous-game/id6670788272';

        if (sourceid) {
            playStoreURL += `&referrer=source=${encodeURIComponent(sourceid)}`;
            appStoreURL += `?mt=${encodeURIComponent(sourceid)}`;
        }

        if (isAndroid) {
            window.location.replace(playStoreURL);
        } else if (isiOS) {
            window.location.replace(appStoreURL);
        } else {
            window.location.replace(playStoreURL);
        }

        setTimeout(() => {
            if (navigator.onLine) {
                if (category === "V2hvVGFsa2lu") {
                    navigate(`/${username}/${category}`);
                } else if (category === "UGljIFJvYXN0") {
                    navigate(`/${username}/${category}/${timestamp}`);
                } else {
                    navigate(`/${username}/${category}`);
                }
            }
        }, 500);
    };



    const handlePslinkPlaystoreClick = async () => {
        if (isButtonDisabled) return; // Prevent action if disabled
        setIsButtonDisabled(true); // Disable all buttons

        // sessionStorage.setItem("timer", "false");
        const isOnline = await checkInternetConnection();
        if (!isOnline) {
            showSnackbar(t?.completePopup?.nointertoast || "Please turn on internet connection!", "error");
            setIsButtonDisabled(false); // Re-enable if error
            return;
        }

        const playstore = 'https://play.google.com/store/apps/details?id=com.prank.android';
        const appstore = 'https://apps.apple.com/us/app/prankster/id6739135275';

        let redirectUrl = playstore;

        if (isiOS) {
            redirectUrl = appstore;
        }

        if (navigator.onLine) {
            window.location.replace(redirectUrl);
        }

        setTimeout(() => {
            if (navigator.onLine) {
                if (category === "V2hvVGFsa2lu") {
                    navigate(`/${username}/${category}`);
                } else if (category === "UGljIFJvYXN0") {
                    navigate(`/${username}/${category}/${timestamp}`);
                } else {
                    navigate(`/${username}/${category}`);
                }
            }
        }, 500);
    };

    const handleClick = async () => {
        if (isButtonDisabled) return; // Prevent action if disabled
        setIsButtonDisabled(true); // Disable all buttons

        // Track event
        logEvent(analytics, "resend_card", {
            page_location: `${window.location.origin}/${username}/${category}`,
            page_path: `/${username}/${category}`,
            debug: "true",
        });

        const isOnline = await checkInternetConnection();
        if (!isOnline) {
            showSnackbar(t?.completePopup?.nointertoast || "Please turn on internet connection!", "error");
            setIsButtonDisabled(false); // Re-enable if error
            return;
        }

        sessionStorage.removeItem("sessionHint")
        sessionStorage.removeItem("sessionImage")
        sessionStorage.removeItem("next")
        sessionStorage.removeItem("que5next")
        sessionStorage.removeItem("que8next")

        sessionStorage.removeItem('steppage_annoyans');
        sessionStorage.removeItem('steppage_scratched');
        sessionStorage.removeItem('steppage_nickname');
        // sessionStorage.setItem("timer", "false");

        // Navigate after tracking
        if (category === "V2hvVGFsa2lu") {
            navigate(`/${username}/${category}`);
            return;
        } else if (category === "UGljIFJvYXN0") {
            navigate(`/${username}/${category}/${timestamp}`);
        } else {
            navigate(`/${username}/${category}`);
        }
    };

    const getBackgroundByCategory = (category) => {

        if (bg) {
            return bg;
        }
        if (category === "RnJpZW5k") {
            return subCat === "RnJpZW5k" ? "#B3ADFD" : "#FF617A";
        }

        switch (category) {
            case "V2hvVGFsa2lu":
                return "#684BB9"; // Solid color
            case "UGljIFJvYXN0":
                return "#2F80ED"; // Solid color
            case "QW5ub3kgZnVuIENhcmQ=":
                return "linear-gradient(to right, #FDAB82, #FF2C7B)"; // Gradient
            case "RW1vdGlvbg==":
                return "#FFA400";
            case "Q29uZmVzc2lvbg==":
                return "#8001CE";
            case "SG90bmVzcw==":
                return "linear-gradient(to right, #FB271A, #FD8C5D)";
            case "Um9hc3Q=":
                return "#F98423";
            case "UnVtb3Vy":
                return "linear-gradient(-90deg, #03C2FE 10%, #DE67FD 100%)";
            case "Q2hhbGxlbmdl":
                return "#7D5EEE";
            case "SGVhdmVuSGVsbA==":
                return "#00C2FF";
            case "UmVwdXRhdGlvbg==":
                return "linear-gradient(to right, #703AFC, #EB7C69)";
            case "SW1wcmVzc2lvbg==":
                return "linear-gradient(to right, #FFB244, #FF408B)";
            default:
                return "linear-gradient(to right, #FA4F55, #FC684B)"; // Default
        }
    };


    return (
        <>
            {showSuccessModal && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{
                        zIndex: 99999,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        backdropFilter: 'blur(8px)',
                        animation: 'fadeIn 0.3s ease-out'
                    }}
                >
                    <div
                        className="popup-bg rounded-5 p-2 m-3 text-center position-relative"
                        style={{
                            maxWidth: '450px',
                            width: '95%',
                            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                            animation: 'slideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                            transform: 'translateY(0)',
                            opacity: 1
                        }}
                    >
                        <div className="mb-4">
                            {/* Success Icon */}
                            <div
                                className={`rounded-circle mx-auto p-1 ${isSmallScreen ? "popup-circle-border" : "popup-circle-border"} d-flex align-items-center justify-content-center mb-3 position-absolute overflow-hidden`}
                                style={{
                                    width: isSmallScreen ? "85px" : "100px",
                                    height: isSmallScreen ? "85px" : "100px",
                                    top: isSmallScreen ? "-38px" : "-50px",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    background: "#F3F3F3",
                                }}
                            >
                                <img src={logo} alt='avatar' className='img-fluid' />
                            </div>

                            {/* Success Title */}
                            <h3 className="popup-main-color my-4 mt-5 d-flex align-items-center justify-content-center gap-2 GTBold" style={{ fontSize: isSmallScreen ? "1.5rem" : "1.75rem" }}>
                                <span>{t.completePopup.sent} </span>
                                <img src={envelope} alt='envelope' width={isSmallScreen ? 28 : 35} className='img-fluid' />
                            </h3>
                            <h5 className='mb-0' style={{ color: "#5A5B5F", fontWeight: "400", fontSize: isSmallScreen ? "1.2rem" : "1.3rem" }}>
                                {t.completePopup.neverMiss}
                            </h5>
                            <h5 className='GTMedium popup-main-color' style={{ fontSize: isSmallScreen ? "1.1rem" : "1.35rem" }}>
                                @{data?.username}
                            </h5>

                            <h6 className={`GTMedium popup-main-color`} style={{ fontSize: isSmallScreen ? "0.9rem" : "1rem", marginTop: isSmallScreen ? "35px" : "40px" }}>
                                👇 <span>{convertToNativeNumerals(count, lanText)}</span> {t.completePopup.peopleTap} 👇
                            </h6>

                            <button
                                className="btn rounded-pill border-0 py-2 mb-2 mt-1 px-2 pulse2 GTMedium"
                                style={{
                                    background: getBackgroundByCategory(category),
                                    padding: isSmallScreen ? "12px 1px" : "14px 1px",
                                    fontSize: isSmallScreen ? "1rem" : "1.25rem",
                                    width: isSmallScreen ? "87%" : "87%",
                                    opacity: 1,
                                    cursor: isButtonDisabled ? 'not-allowed' : 'pointer'
                                }}
                                onClick={handlePlaystoreClick}
                                disabled={isButtonDisabled}
                            >
                                <p className="text-decoration-none text-white m-0" style={{ fontSize: isSmallScreen ? "1.12rem" : "1.25rem" }}>
                                    {t.completePopup.getOwnMessage}
                                </p>
                            </button>

                            <p
                                className="GTBold m-0 popup-main-color"
                                style={{
                                    fontSize: isSmallScreen ? "14px" : "15px",
                                    cursor: isButtonDisabled ? 'not-allowed' : 'pointer',
                                    textDecoration: "underline",
                                    opacity: 1,
                                    pointerEvents: isButtonDisabled ? 'none' : 'auto'
                                }}
                                onClick={handleClick}
                            >
                                {t.completePopup.sendAnother}
                            </p>

                            <button
                                className={`btn rounded-pill popup-main-color GTMedium popup-border-complete`}
                                onClick={handlePslinkPlaystoreClick}
                                disabled={isButtonDisabled}
                                style={{
                                    width: "85%",
                                    fontWeight: "700",
                                    padding: isSmallScreen ? "11px 1px" : "13px 1px",
                                    fontSize: isSmallScreen ? "16px" : "18px",
                                    marginTop: isSmallScreen ? "35px" : "40px",
                                    opacity: 1,
                                    cursor: isButtonDisabled ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {t.completePopup.newAppFrom}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Add CSS animations */}
            <style jsx>{`
            @keyframes fadeIn {
                from {
                    opacity: 0;
                }
                to {
                    opacity: 1;
                }
            }

            @keyframes slideUp {
                from {
                    transform: translateY(50px);
                    opacity: 0;
                }
                to {
                    transform: translateY(0);
                    opacity: 1;
                }
            }

            @keyframes scaleIn {
                from {
                    transform: translateX(-50%) scale(0);
                    opacity: 0;
                }
                to {
                    transform: translateX(-50%) scale(1);
                    opacity: 1;
                }
            }

            @keyframes fadeInUp {
                from {
                    transform: translateY(20px);
                    opacity: 0;
                }
                to {
                    transform: translateY(0);
                    opacity: 1;
                }
            }

            .pulse {
                animation: pulse 2s infinite;
            }

            @keyframes pulse {
                0% {
                    box-shadow: 0 0 0 0 rgba(245, 81, 82, 0.7);
                }
                70% {
                    box-shadow: 0 0 0 10px rgba(245, 81, 82, 0);
                }
                100% {
                    box-shadow: 0 0 0 0 rgba(245, 81, 82, 0);
                }
            }
        `}</style>
        </>
    );
};

export default CompletePopup